import { People } from '@mui/icons-material';
import { Alert, AlertTitle, Divider, Box } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { RecipientList } from 'src/modules/groupMessageEmail/components/recipientList';
import { CreateInvoiceSelectMissionType } from 'src/modules/invoice/components/createInvoiceSelectInvoiceMissionType';
import { GenericDialog } from 'src/shared/components/organisms/genericDialog';
import { InvoiceMissionTypeEnum } from 'src/shared/models/enums/invoiceMissionType.enum';
import { useState } from 'react';
import { GetInvoiceMissionTypes } from 'src/modules/invoice/components/invoiceMissionTypes';
import { Member } from '../models/member';
import { MemberCreateInvoiceModalForGiftOrPurchase } from './memberCreateInvoiceModalForGiftOrPurchase';
import { MemberCreateInvoiceModalForMemberFee } from './memberCreateInvoiceModalForMemberFee';

type MemberCreateInvoiceProps = {
  otherContactMode: boolean;
  member?: Member;
  members?: Member[];
  modalOpen: boolean;
  onClose: () => void;
  onSave: () => void;
};

export const MemberCreateInvoice = (props: MemberCreateInvoiceProps) => {
  const { otherContactMode, member = undefined, members = undefined, modalOpen, onClose, onSave } = props;
  const { t } = useTranslation(['common', 'invoice']);

  const [invoiceMissionId, setInvoiceMissionId] = useState<InvoiceMissionTypeEnum>();

  const createInvoiceMissionTypes = GetInvoiceMissionTypes({ otherContactMode, showMemberFee: true });

  const onHandleClose = () => {
    onClose();
    setInvoiceMissionId(undefined);
  };

  const onHandleSave = () => {
    onSave();
    setInvoiceMissionId(undefined);
  };

  return (
    <>
      <GenericDialog
        open={modalOpen && !invoiceMissionId}
        onClose={onHandleClose}
        onSave={onHandleSave}
        dialogTitle={t('invoice:createInvoice.modalHeader')}
        showDialogActions={false}
        padding={0}
        dialogContent={
          <Box>
            <Alert icon={false} severity='info' sx={{ m: 0 }}>
              {(member || members) && (
                <AlertTitle sx={{ display: 'flex', alignItems: 'center' }}>
                  <People fontSize='small' sx={{ mr: 1 }} aria-hidden />
                  {t('groupMessage:selection.recipients')}&nbsp;<strong>({members && members.length ? members.length : 1})</strong>
                </AlertTitle>
              )}
              {member && <RecipientList members={[member]} />}
              {members && <RecipientList members={members} />}
            </Alert>
            <Divider />
            <Box sx={{ p: 3 }}>
              <CreateInvoiceSelectMissionType createInvoiceMissionTypes={createInvoiceMissionTypes} callback={(x) => setInvoiceMissionId(x)} />
            </Box>
          </Box>
        }
      />
      {invoiceMissionId && invoiceMissionId !== InvoiceMissionTypeEnum.MemberFee && (
        <MemberCreateInvoiceModalForGiftOrPurchase
          member={member}
          members={members}
          invoiceMissionId={invoiceMissionId}
          modalOpen={!!invoiceMissionId}
          onClose={onHandleClose}
          onSave={onHandleSave}
        />
      )}
      {invoiceMissionId && invoiceMissionId === InvoiceMissionTypeEnum.MemberFee && (
        <MemberCreateInvoiceModalForMemberFee
          member={member}
          members={members}
          modalOpen={!!invoiceMissionId}
          onClose={onHandleClose}
          onSave={onHandleSave}
        />
      )}
    </>
  );
};
